// Slug is restricted to lowercase `[a-z0-9-]`, strictly narrower
// than RFC 6266 / `Content-Disposition: filename="..."` accepts, so
// the client never relies on server-side escape behavior.
const DEFAULT_FILENAME = "polly-chart.xlsx";
// 80 keeps the filename well under the 255-char backend ceiling.
const MAX_SLUG_LENGTH = 80;

// U+0300..U+036F: Combining Diacritical Marks. NFKD splits "é" into
// "e" + U+0301; this regex strips the combining half so the base
// letter survives the ASCII filter below. Written with explicit
// `\u` escapes; the literal codepoints are invisible glyphs that
// editors can mangle on copy/paste.
const COMBINING_DIACRITICS_RE = /[\u0300-\u036F]/gu;

export function titleToFilename(title: string | undefined | null): string {
    if (!title) return DEFAULT_FILENAME;

    const slug = title
        .normalize("NFKD")
        .replace(COMBINING_DIACRITICS_RE, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .slice(0, MAX_SLUG_LENGTH)
        // Cap might have sliced mid-separator; clean up the tail.
        .replace(/-+$/, "");

    if (!slug) return DEFAULT_FILENAME;
    return `${slug}.xlsx`;
}
